import { createContext } from 'react';

export default createContext({
  labels: null
});
